import { render, staticRenderFns } from "./QRMProductCode.vue?vue&type=template&id=4e87eff0&"
import script from "./QRMProductCode.vue?vue&type=script&lang=js&"
export * from "./QRMProductCode.vue?vue&type=script&lang=js&"
import style0 from "./QRMProductCode.vue?vue&type=style&index=0&id=4e87eff0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports